// API URLs
export default {
  PHONES: '/phones',
  LEAD_SOURCE: '/lead-source',
};
